<template>
  <vs-chip :color="badgeContext">{{ badgeContent }}</vs-chip>
</template>

<script>
export default {
  name: 'BadgeSmsResult',
  props: {
    content: {
      type: [String, Number],
      required: true
    }
  },
  computed: {
    badgeContent () {
      return this.$t(`code_${this.content}`)
    },
    badgeContext () {
      if (this.content === '0000') {
        return 'success'
      }

      return 'danger'
    }
  }
}
</script>

<style scoped>

</style>
